var React = require('react');

function NavClose (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m21 19h10v2h-10v10h-2v-10h-10v-2h10v-10h2z","fillRule":"evenodd","transform":"matrix(.70710678 .70710678 -.70710678 .70710678 20 -8.284271)"}));
}

NavClose.defaultProps = {"viewBox":"10 10 20 20"};

module.exports = NavClose;

NavClose.default = NavClose;
